export const movies = [
  {
    id: "1001",
    title: "星河之下",
    subtitle: "Under the Galaxy · 科幻史诗",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20of%20a%20lone%20astronaut%20facing%20a%20giant%20spiral%20galaxy%2C%20deep%20space%20nebula%2C%20teal%20and%20orange%20color%20grading%2C%20dramatic%20rim%20lighting%2C%20high%20detail%2C%20vertical%20composition&width=600&height=900&seq=movie-poster-1001&orientation=portrait",
    director: "陈望舒",
    cast: ["陆则鸣", "苏晚晴", "高野"],
    genre: "科幻",
    region: "中国大陆",
    year: 2026,
    releaseDate: "2026-03-18",
    duration: "132分钟",
    summary: "一艘失联百年的殖民舰重回太阳系，带回的不只是幸存者，还有一个改写人类命运的坐标。",
    synopsis: "人类第一批深空殖民舰「星河号」在失联一个世纪后突然重返太阳系边缘。天体物理学家陆则鸣受命登舰调查，却发现舰上时间只过去了三年，船员对地球上发生的一切毫不知情。随着调查深入，一个来自银河系深处的坐标浮出水面——那里，或许藏着人类文明真正的起源答案。影片以冷峻的科幻外壳包裹关于孤独与归乡的追问，视觉奇观与人文内核并重。",
    tags: ["太空歌剧", "硬科幻", "悬疑"],
    heat: 9860,
  },
  {
    id: "1002",
    title: "都市迷雾",
    subtitle: "Urban Mist · 都市悬疑",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20of%20a%20foggy%20modern%20city%20skyline%20at%20night%2C%20a%20lone%20detective%20silhouette%20with%20umbrella%2C%20teal%20and%20amber%20tones%2C%20moody%20neon%20reflections%2C%20high%20detail%2C%20vertical%20composition&width=600&height=900&seq=movie-poster-1002&orientation=portrait",
    director: "林砚舟",
    cast: ["周凛", "许清禾", "沈彻"],
    genre: "悬疑",
    region: "中国大陆",
    year: 2025,
    releaseDate: "2025-11-07",
    duration: "118分钟",
    summary: "七起看似无关的失踪案，指向同一段被抹去的城市记忆。",
    synopsis: "刑警周凛接手一起普通的失踪案，却在走访中发现了七起跨越十年的相似案件。所有线索都指向城郊一片早已拆除的老城区，而那里正是他童年生活的地方。当调查逼近真相，周凛意识到，被迷雾覆盖的不只是案件，还有他自己被篡改的过去。影片以纪实的镜头语言，勾勒出一座城市在高速发展中留下的阴影。",
    tags: ["犯罪", "烧脑", "社会派"],
    heat: 8720,
  },
  {
    id: "1003",
    title: "山海归途",
    subtitle: "Journey Home · 东方奇幻",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20of%20an%20oriental%20mythical%20mountain%20landscape%20with%20floating%20islands%2C%20misty%20peaks%20and%20a%20traveler%20on%20a%20bridge%2C%20teal%20ink%20painting%20style%20with%20warm%20orange%20accents%2C%20epic%20tone%2C%20vertical%20composition&width=600&height=900&seq=movie-poster-1003&orientation=portrait",
    director: "白栖梧",
    cast: ["江澈", "云知微", "岑砚"],
    genre: "奇幻",
    region: "中国香港",
    year: 2026,
    releaseDate: "2026-06-01",
    duration: "140分钟",
    summary: "少年背负一卷失传的山海图，踏上寻回家园的千年归途。",
    synopsis: "在人妖共存的上古时代，少年江澈从祖父遗物中得到半卷残破的山海图。图中标注的路线通往传说中能实现任何愿望的「归墟」。为了找回被掳走的妹妹，他独自踏上旅途，在沿途结识了化形人云的少女云知微与浪荡剑客岑砚。三人穿越山海异境，逐渐揭开这幅图卷背后关于天地秩序的秘密。影片以水墨与实景结合的画面，呈现出瑰丽的东方奇幻世界。",
    tags: ["神话", "冒险", "水墨美学"],
    heat: 9180,
  },
  {
    id: "1004",
    title: "光影年代",
    subtitle: "Golden Era · 年代剧情",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20of%20a%201980s%20vintage%20cinema%20in%20a%20chinese%20town%2C%20warm%20projector%20light%2C%20retro%20posters%20and%20bicycles%2C%20teal%20shadows%20with%20amber%20highlights%2C%20nostalgic%20mood%2C%20vertical%20composition&width=600&height=900&seq=movie-poster-1004&orientation=portrait",
    director: "郑守拙",
    cast: ["黎满仓", "何彩云", "小万"],
    genre: "剧情",
    region: "中国大陆",
    year: 2025,
    releaseDate: "2025-09-20",
    duration: "126分钟",
    summary: "一个小镇放映员的一生，映照出中国电影四十年的流金岁月。",
    synopsis: "1980年，年轻的黎满仓成为镇上唯一的电影放映员。他背着放映机走遍十里八乡，把光影带进每一个村庄。四十年间，胶片变成数字，露天影院变成商场影城，观众来了又走，而黎满仓始终守在那束光里。影片通过一个小人物的坚守，串起时代变迁中关于热爱与告别的集体记忆。",
    tags: ["怀旧", "温情", "时代记忆"],
    heat: 7460,
  },
  {
    id: "1005",
    title: "深海回响",
    subtitle: "Deep Sea Echo · 灾难惊悚",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20of%20a%20deep%20sea%20research%20submarine%20in%20dark%20ocean%20trench%2C%20eerie%20glowing%20bioluminescence%2C%20teal%20underwater%20light%20with%20amber%20warning%20glow%2C%20tense%20atmosphere%2C%20vertical%20composition&width=600&height=900&seq=movie-poster-1005&orientation=portrait",
    director: "柳砚川",
    cast: ["程蔚", "南嘉", "柏川"],
    genre: "惊悚",
    region: "中国台湾",
    year: 2026,
    releaseDate: "2026-01-29",
    duration: "110分钟",
    summary: "万米海沟深处传来的一段信号，让科考队陷入无法逃脱的深渊。",
    synopsis: "深海科考潜艇「回声号」在挑战者深渊执行例行探测时，接收到一段规律的人造信号。队长程蔚决定追踪信号来源，却意外触发了海底甲烷层的连锁反应。潜艇受损、氧气告急，船员被困在万米之下。随着生存空间不断缩小，团队内部的信任也开始崩塌。影片以密闭空间与压迫感十足的氛围，探讨绝境中的人性抉择。",
    tags: ["灾难", "密闭空间", "紧张"],
    heat: 8030,
  },
  {
    id: "1006",
    title: "春日慢板",
    subtitle: "Spring Adagio · 治愈爱情",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20romantic%20movie%20poster%20of%20a%20small%20coastal%20town%20in%20spring%2C%20cherry%20blossoms%20and%20a%20caf%C3%A9%20by%20the%20sea%2C%20soft%20teal%20sky%20with%20warm%20orange%20sunset%2C%20gentle%20nostalgic%20mood%2C%20vertical%20composition&width=600&height=900&seq=movie-poster-1006&orientation=portrait",
    director: "温柚",
    cast: ["苏念", "顾清和", "阿荔"],
    genre: "爱情",
    region: "中国大陆",
    year: 2025,
    releaseDate: "2025-04-12",
    duration: "104分钟",
    summary: "一位失意的小提琴手与海边咖啡店老板，用一个春天慢慢靠近。",
    synopsis: "小提琴手苏念在重要比赛失利后，独自来到南方海滨小镇疗伤。她住进一家面朝大海的老咖啡店，店主顾清和是个沉默寡言却心思细腻的人。两人从陌生到熟悉，在慢节奏的日子里互相治愈。当春天的最后一场雨落下，苏念终于找回拉琴的勇气，也找到了留下来的理由。影片温柔克制，像一段缓缓流淌的慢板乐章。",
    tags: ["治愈", "文艺", "慢节奏"],
    heat: 6890,
  },
  {
    id: "1007",
    title: "铁血长征",
    subtitle: "Iron March · 战争动作",
    cover: "https://readdy.ai/api/search-image?query=epic%20war%20movie%20poster%20of%20soldiers%20marching%20across%20snowy%20mountains%20at%20dawn%2C%20dramatic%20clouds%20and%20red%20banner%2C%20teal%20cold%20tones%20with%20emblem%20orange%20glow%2C%20heroic%20tone%2C%20vertical%20composition&width=600&height=900&seq=movie-poster-1007&orientation=portrait",
    director: "关山月",
    cast: ["铁木", "罗征", "韩霜"],
    genre: "战争",
    region: "中国大陆",
    year: 2025,
    releaseDate: "2025-08-01",
    duration: "148分钟",
    summary: "一支先遣队在雪山绝境中，用血肉之躯踏出一条通路。",
    synopsis: "1935年冬，红军先遣队奉命翻越一座从未有人成功穿越的雪山，为后续部队探路。队长铁木带领三十余名战士，在暴风雪、饥饿与敌军的追击中艰难前行。每一步都是生与死的考验，而他们心中只有一个信念——让大部队走出去。影片以写实的战场场面与坚定的群像塑造，再现那段令人动容的征程。",
    tags: ["主旋律", "群像", "热血"],
    heat: 8210,
  },
  {
    id: "1008",
    title: "幻城之主",
    subtitle: "Lord of Illusion · 玄幻权谋",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20fantasy%20poster%20of%20a%20mysterious%20ruler%20on%20a%20throne%20in%20a%20floating%20magical%20palace%2C%20glowing%20runes%20and%20ancient%20pillars%2C%20teal%20magic%20light%20with%20golden%20orange%20accents%2C%20regal%20tone%2C%20vertical%20composition&width=600&height=900&seq=movie-poster-1008&orientation=portrait",
    director: "萧无涯",
    cast: ["凌阙", "玉疏影", "沈墨白"],
    genre: "奇幻",
    region: "中国大陆",
    year: 2026,
    releaseDate: "2026-02-14",
    duration: "136分钟",
    summary: "当整座城都由幻术构筑，唯一真实的，是那份想要守护的心。",
    synopsis: "传说中漂浮于云端的「幻城」，由历代城主的幻术维系。年轻的继任者凌阙登上城主之位后，发现整座城的存续都依赖一个残忍的秘密。为了打破延续千年的循环，他必须在幻象与真实之间做出抉择。而当竹马玉疏影卷入权力漩涡，凌阙意识到，最强大的幻术从来不是欺骗别人，而是说服自己。影片构建了一个瑰丽而危险的东方奇幻世界。",
    tags: ["权谋", "世界观", "特效"],
    heat: 9040,
  },
  {
    id: "1009",
    title: "追风少年",
    subtitle: "Wind Chaser · 青春运动",
    cover: "https://readdy.ai/api/search-image?query=energetic%20sports%20movie%20poster%20of%20young%20cyclists%20racing%20along%20a%20coastal%20road%20at%20sunrise%2C%20motion%20blur%20and%20flying%20dust%2C%20teal%20sky%20with%20warm%20orange%20sunlight%2C%20youthful%20dynamic%20tone%2C%20vertical%20composition&width=600&height=900&seq=movie-poster-1009&orientation=portrait",
    director: "骆一鸣",
    cast: ["任飞", "夏小满", "老周"],
    genre: "青春",
    region: "中国大陆",
    year: 2025,
    releaseDate: "2025-07-15",
    duration: "112分钟",
    summary: "一支濒临解散的县城自行车队，向着全国大赛发起最后冲刺。",
    synopsis: "县城中学的自行车队因经费不足面临解散，队长任飞却不愿放弃。他召集起几个被忽视的少年，在退役车手老周的带领下，用最简陋的条件开始魔鬼训练。从被人嘲笑的业余队伍，到闯入全国大赛的黑马，他们用一次次摔倒与爬起证明：梦想从不问出身。影片热血励志，充满少年人的冲劲与汗水。",
    tags: ["励志", "竞技", "成长"],
    heat: 7120,
  },
];